import { isProvisionalIdentifier } from '../../../../../lib/util';

const documentSavePath = '/api/v1/document/save';
const documentFetchPath = '/document/event';
const documentRemovePath = '/document/remove';


class AddPhotosModalController {
  constructor(
    $scope,
    $window,
    $uibModalInstance,
    $q,
    $translate,
    showConfirmModal,
    translateFilter,
    position,
    APIService,
    API_URL,
    LogService,
    StaffUserService,
    DocumentService
  ) {
    "ngInject";

    this.$window = $window;
    this.$scope = $scope;
    this.$uibModalInstance = $uibModalInstance;
    this.$q = $q;
    this.$translate = $translate;
    this.showConfirmModal = showConfirmModal;
    this.translateFilter = translateFilter;
    this.position = position;
    this.APIService = APIService;
    this.API_URL = API_URL;
    this.LogService = LogService;
    this.StaffUserService = StaffUserService;
    this.DocumentService = DocumentService;
    this._documents = [];
    this._removeDocuments = [];
    this._loadingCount = 0;
  }

  $onInit() {
    this._loadDocuments();
  }

  set documents(documents) {
    this._documents = documents;
  }

  get documents() {
    return this._documents;
  }

  set newFile(file) {
    this._newFile = file;
  }

  get newFile() {
    return this._newFile;
  }

  set documentIds(documentIdList) {
    this.value = documentIdList.join(',');
  }

  get documentIds() {
    let ids = [];
    if (this.value) {
      ids = this.value.split('|').map(id => normalizeIdentifier(id)) || [];
    }
    return ids;
  }

  get documentsPendingUpload() {
    return this.documents
      .filter(document => isProvisionalIdentifier(document.id));
  }

  get numberOfPendingUploads() {
    return this.documentsPendingUpload.length;
  }

  get documentIdsPendingRemoval() {
    return this._removeDocuments
      .filter(docId => !isProvisionalIdentifier(docId));
  }

  get numberOfPendingRemovals() {
    return this.documentIdsPendingRemoval.length;
  }

  get havePendingOperations() {
    return this.numberOfPendingUploads > 0 || this.numberOfPendingRemovals > 0;
  }

  get loading() {
    return this._loadingCount > 0;
  }

  startLoading() {
    this._loadingCount += 1;
  }

  endLoading() {
    this._loadingCount -= 1;
  }

  canRotate(document) {
    return (document && document.id && isProvisionalIdentifier(document.id));
  }

  fileChanged($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
    if ($files.length > 1) {
      const promises = [];
      for (let i = 0; i <= $files.length; i++) {
        if ($files[i] && $files[i].name) {

          // Create document from file
          const promise = this.DocumentService.createWithLocalFile($files[i])
            .then(document => this.DocumentService.resizeDocument(document))
            .then(document => {
              this.documents.push(document);
              this.newFile = null;
            })
            .catch(err => {
              this.LogService.error("Error creating document:", err);
              return this.$q.reject(err);
            });
          promises.push(promise);
        }
      }
      return promises;
    } else {
      // Create document from file
      return this.DocumentService.createWithLocalFile($file)
        .then(document => this.DocumentService.resizeDocument(document))
        .then(document => {
          this.documents.push(document);
          this.newFile = null;
        })
        .catch(err => {
          this.LogService.error("Error creating document:", err);
          return this.$q.reject(err);
        });
    }
  }


  removeDocument(document) {
    if (!isProvisionalIdentifier(document.id)) {
      this._removeDocuments.push(document.id);
    }

    // Finally, remove document from our own list
    this._documents = this._documents.filter(currDoc => currDoc.id !== document.id);
  }

  rotateDocumentLeft(document) {
    return this.rotateDocument(document, false);
  }

  rotateDocumentRight(document) {
    return this.rotateDocument(document, true);
  }

  rotateDocument(document, rotateDirectionRight = true) {
    let deferred = this.$q.defer();
    let canvas = this.$window.document.createElement('canvas');
    let img = this.$window.document.createElement('img');
    let type = 'image/jpeg';
    let quality = 0.934;

    img.onload = () => {
      try {
        canvas.width = img.height;
        canvas.height = img.width;

        let ctx = canvas.getContext('2d');

        // Set rotation transform
        if (rotateDirectionRight) {
          ctx.transform(0, 1, -1, 0, img.height, 0);
        } else {
          ctx.transform(0, -1, 1, 0, 0, img.width);
        }

        // Draw image
        ctx.drawImage(img, 0, 0);

        // // Clear context
        // ctx.clearRect(0, 0, canvas.width, canvas.height);
        //
        // // Translate canvas so we will rotate around center point
        // ctx.translate(canvas.width / 2, canvas.height / 2);
        //
        // // Do 90 degree rotation
        // ctx.rotate((Math.PI / 180) * rotateDegrees);
        //
        // // Translate canvas back to origin
        // ctx.translate(-canvas.width / 2, -canvas.height / 2);

        // Retrieve new data URL
        document.fileDataURL = canvas.toDataURL(type, quality);
        deferred.resolve(document);
      } catch (e) {
        return deferred.reject(e);
      }
    };

    img.onerror = () => {
      deferred.reject();
    };

    img.src = document.fileDataURL;

    return deferred.promise
      .then(document => {
        return document;
      })
      .catch(err => {
        this.LogService.warn("Error rotating document:", err);
        return this.$q.reject(err);
      });
  }

  _loadDocuments() {
    this.documents = [];
    this._removeDocuments = [];

    if (this.position && this.position.real_events_id && this.position.staffing_users_id) {
      this.startLoading();
      const promise = this.DocumentService.getEventDocuments(documentFetchPath, this.position.real_events_id, this.position.staffing_users_id);
      return promise
        .then(documents => {
          this.documents = documents;
          this.endLoading();
        });
    } else {
      return this.$q.when(null);
    }
  }

  _removeDocumentsFromServer() {
    if (this._removeDocuments.length > 0) {
      this.startLoading();
      return this.$q.when(this.DocumentService.removeFromServer(documentRemovePath, this._removeDocuments))
        .then(result => {
          this.endLoading();
          return result;
        });
    }
    return this.$q.when(false);
  }

  submit() {
    return this.$q.when(this.startLoading())
      .then(() => this.LogService.info(`AddPhotosModalController.submit() starting upload`))
      .then(() => this._uploadDocs())
      .then(() => this.LogService.info(`AddPhotosModalController.submit() finished upload`))
      .then(() => this._removeDocumentsFromServer())
      .then(() => this.LogService.info(`AddPhotosModalController.submit() finished remove`))
      .then(() => this._loadDocuments())
      .then(() => this.LogService.info(`AddPhotosModalController.submit() finished load`))
      .then(() => this.endLoading())
      .then(() => this.LogService.info(`AddPhotosModalController.submit() showing complete modal`))
      .then(() => this._showUploadCompleteModal())
  }

  _uploadDocs() {
    const provisionalIdentifierMap = {};
    const uploadPromises =
      this.documentsPendingUpload
      .map(document => {
        const serialized = this.DocumentService.serialize(document);
        const data = {
          events_id: this.position.real_events_id,
          staffing_users_id: this.position.staffing_users_id,
        };
        return this.$q.when(this.DocumentService.upload(serialized, documentSavePath, data, 'file'))
          .then(uploadResult => {
            // TODO: Update ID's in document
            provisionalIdentifierMap[document.id] = uploadResult.id;
            return uploadResult;
          })
      })
    return this.$q.all(uploadPromises)
      .then(results => {
        return results;
      });
  }

  _showUploadCompleteModal() {
    return this.$translate('UPLOAD_COMPLETE')
      .then(uploadCompleteMessage => this.showConfirmModal(uploadCompleteMessage));
  }

  close() {
    if (this.havePendingOperations) {
      // TODO: Show a modal warning user that they're cancelling?
    }

    this.$uibModalInstance.dismiss('cancel');
  }
}

export default AddPhotosModalController;

